import React from 'react';
import { View } from 'react-native';
import { Icon } from '@ant-design/react-native';
import { Text as UIKitText } from '@sendbird/uikit-react-native-foundation';
import { colorPalette } from '@shared/config/colorsConfig';
import { CHAT_ATTACHMENT_TEXT_STYLE } from '../../constants';
import type { TChatAttachmentLabelProps } from '../../types';

export const ChatAttachmentLabel = ({ attachment }: TChatAttachmentLabelProps) => (
    <View className="flex-row items-center gap-2">
        <Icon
            name={attachment.isImage ? 'picture' : 'paper-clip'}
            size={20}
            color={colorPalette.secondary[600]}
        />
        <UIKitText
            body3
            numberOfLines={1}
            ellipsizeMode="middle"
            style={CHAT_ATTACHMENT_TEXT_STYLE}
            color={colorPalette.black}
        >
            {attachment.label}
        </UIKitText>
    </View>
);
